import React from 'react';
import umbrella from 'umbrella-storage';
import { Tooltip } from 'antd';
import { PermissionCode } from '../../models/v2';
import Cookies from 'js-cookie';
import { canUseRecipientLists } from '../../utils/roles';

interface PermissionGuardProps {
    anyOf: PermissionCode[];
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export const currentPermissions = (): string[] => {
    const user = umbrella.getLocalStorage('user') || {};
    const permissions = user.permissions || user.permissionCodes;
    return Array.isArray(permissions) ? permissions : [];
};

export const hasPermission = (permissions: PermissionCode[]) => {
    const current = currentPermissions();
    const legacyRole = parseInt(Cookies.get('userRole') || '0', 10);
    if (legacyRole >= 1000) return true;
    if (permissions.some((permission) => permission.startsWith('RECIPIENT_LIST_')
        || permission.startsWith('OUTREACH_BATCH_')
        || permission === 'OUTREACH_RECIPIENT_RETRY')
        && canUseRecipientLists(legacyRole)) return true;
    // V2 /auth/me 尚未接入时，按钮可见性只作提示，最终由服务端授权。
    return current.length === 0 || permissions.some((permission) => current.includes(permission));
};

const PermissionGuard = ({ anyOf, children, fallback }: PermissionGuardProps) => {
    if (hasPermission(anyOf)) return <>{children}</>;
    return (
        <>
            {fallback || (
                <Tooltip title="当前账号没有此操作权限">
                    <span />
                </Tooltip>
            )}
        </>
    );
};

export default PermissionGuard;
